import type { UserUuid } from "../identity";

export interface XoeFocus {
	routeLabel?: string;
	sectionLabel?: string;
	patientId?: UserUuid;
	patientLabel?: string;
	wheel?: XoeWheelFocus;
	inConsult?: boolean;
}

/**
 * which wheel the practitioner is building in, published by WheelDashboard in build mode only.
 */
export interface XoeWheelFocus {
	panelId: number;
	traitId?: number;
	wheelGeneId?: number | null;
}

/**
 * Route path → screen label. EXACT `pathname` match, built from the real routes in
 * `App.tsx`.
 */
export const XOE_ROUTE_LABELS: Record<string, string> = {
	"/": "Dashboard",

	// Healthcare
	"/healthcare/patients": "Patients",
	"/healthcare/appointments": "Appointments",
	"/healthcare/communications": "Communications",
	"/healthcare/results": "Test orders",
	"/healthcare/intray": "Results in tray",
	"/healthcare/forms-intray": "Forms in tray",
	"/healthcare/treatment-plans": "Treatment plans",
	"/healthcare/peptide-dashboard": "Peptide plans",

	// Laboratory
	"/lab/orders": "Lab orders",
	"/lab/processing": "Sample processing",

	// Gene.Codes
	"/gene.codes/wheel": "Genetic wheel",
	"/gene.codes/wheel/build": "Genetic wheel",

	// Research
	"/research": "Research",

	// Xoe
	"/xoe": "Xoe assistant",

	// Inventory & commerce
	"/inventory/products": "Stock",
	"/inventory/commerce/products": "Commerce products",
	"/inventory/orders": "Inventory orders",

	// Finance
	"/finance/payments": "Payments",
	"/finance/invoices": "Invoices",
	"/finance/subscriptions": "Subscriptions",

	// Admin & audit
	"/admin/users": "Users",
	"/admin/test-management": "Test management",
	"/admin/hi-alerts": "HI reviews",
	"/audit": "Audit log",

	// Settings & profile
	"/settings/forms": "Form builder",
	"/settings/report-templates": "Report templates",
	"/profile": "Profile",
	"/help": "Help",
};

/**
 * The four parameterised PRACTITIONER routes, keyed by their static prefix.
 */
export const XOE_ROUTE_PREFIX_LABELS: Record<string, string> = {
	"/lab/tracking": "Sample tracking",
	"/lab/protocols/builder": "Protocol builder",
	"/settings/treatment-plans/builder": "Treatment plan builder",
	"/settings/note-templates/builder": "Note template builder",
};

/**
 * PatientModal tab KEY → the label the practitioner actually reads, taken from the real
 * `tabItems` in `PatientModal.tsx`.
 */
export const XOE_SECTION_LABELS: Record<string, string> = {
	Overview: "Overview",
	Personal: "Personal Info",
	Billing: "Billing",
	Appointments: "Appointments",
	Forms: "Forms",
	"Medical History": "Medical History",
	Medications: "Medications",
	Notifications: "Notifications",
	orders: "Orders",
	Files: "Resources",
	Supplements: "Supplements",
	Testing: "Testing",
	TreatmentPlans: "Treatment Plans",
	Vitals: "Vitals",
};
